import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Navbar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			breakingNews: [],
			activeIndex: 0,
			currentDate: new Date(),
			categories: []
		};
	}

	formatDate(date) {
		const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
		return date.toLocaleDateString(undefined, options);
	}

	fetchBreakingNews() {
		const apiUrlBreakingNews = 'https://khapa.tagit.pk/api/blog.php?news=home_posts&section=latest_news&limit=5';
	
		fetch(apiUrlBreakingNews)
		  .then(response => response.json())
		  .then(data => {
			// Assuming the data contains an array of breaking news articles
			if (Array.isArray(data)) {
			  const formattedNews = data.map(item => ({
				title: item.title || 'No title available',
				link: `/news-details/${item.id}` || '#'
			  }));
			  this.setState({ breakingNews: formattedNews });
			} else {
			  console.error('Unexpected data format:', data);
			}
		  })
		  .catch(error => console.error('Error fetching breaking news:', error));
	  }

	fetchCategories() {
		const apiUrlNewsCat = 'https://khapa.tagit.pk/api/blog.php?category=news_categories';

		fetch(apiUrlNewsCat)
			.then(response => response.json())
			.then(data => {
				// Assuming the data is an array of categories
				if (Array.isArray(data)) {
					this.setState({ categories: data });
				} else {
					console.error('Unexpected data format:', data);
				}
			})
			.catch(error => console.error('Error fetching categories:', error));
	}

	componentDidMount() {
		this.interval = setInterval(() => {
			this.setState(prevState => ({
				activeIndex: (prevState.activeIndex + 1) % prevState.breakingNews.length
			}));
		}, 3000); // Change slide every 3 seconds
		this.fetchBreakingNews();
		this.fetchCategories();
	}

	componentWillUnmount() {
		clearInterval(this.interval);
	}


	render() {
		let publicUrl = process.env.PUBLIC_URL + '/'
		const { breakingNews, activeIndex, currentDate, categories } = this.state;

		return (
			<div className="navbar-area">
				{/* topbar end*/}
				<div className="topbar-area">
					<div className="container">
						<div className="row justify-content-center">
							<div className="col-lg-6 col-md-7 align-self-center">
								<div className="topbar-menu text-md-left text-center">
									<div className="breaking-news">
										<p className="breaking-title"><i class="fa fa-fire"></i> BREAKING!</p>
										<div className="breaking-news-content">
											{breakingNews.map((news, index) => (
												<div
													key={index}
													className={`single-breaking-news ${index === activeIndex ? 'active' : ''}`}
												>
													<h6 className="breaking-list-title">
														<a href={news.link} target="_blank" rel="noopener noreferrer">
															{news.title}
														</a>
													</h6>
												</div>
											))}
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-6 col-md-5 mt-2 mt-md-0 text-md-right text-center">
								<div className="topbar-social">
									<div className="topbar-date d-none d-lg-inline-block"><i className="fa fa-calendar" /> {this.formatDate(currentDate)}</div>
									<ul className="social-area social-area-2">
										<li><a className="facebook-icon" href="#"><i className="fa fa-facebook" /></a></li>
										<li><a className="twitter-icon" href="#"><i className="fa fa-twitter" /></a></li>
										<li><a className="youtube-icon" href="#"><i className="fa fa-youtube-play" /></a></li>
										<li><a className="instagram-icon" href="#"><i className="fa fa-instagram" /></a></li>
										<li><a className="linkedin-icon" href="#"><i className="fa fa-linkedin" /></a></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* topbar end*/}
				{/* adbar end*/}
				<div className="adbar-area d-none d-lg-block">
					<div className="container">
						<div className="row">
							<div className="col-xl-6 col-lg-5 align-self-center">
								<div className="logo text-md-left text-center">
									<Link className="main-logo" to="/"><img src={publicUrl + "assets/img/logo.png"} alt="img" width={70} /></Link>
								</div>
							</div>
							<div className="col-xl-6 col-lg-7 text-md-right text-center">
								<a href="#" className="adbar-right">
									<img src={publicUrl + "assets/img/add/soccer-template-design.png"} alt="img" />
								</a>
							</div>
						</div>
					</div>
				</div>
				{/* adbar end*/}
				{/* navbar start */}
				<nav className="navbar navbar-expand-lg">
					<div className="container nav-container">
						<div className="responsive-mobile-menu">
							<div className="logo d-lg-none d-block">
								<Link className="main-logo" to="/"><img src={publicUrl + "assets/img/logo.png"} alt="img" /></Link>
							</div>
							<button className="menu toggle-btn d-block d-lg-none" data-target="#nextpage_main_menu" aria-expanded="false" aria-label="Toggle navigation">
								<span className="icon-left" />
								<span className="icon-right" />
							</button>
						</div>
						<div className="nav-right-part nav-right-part-mobile">
							<a className="search header-search" href="#"><i className="fa fa-search" /></a>
						</div>
						<div className="collapse navbar-collapse" id="nextpage_main_menu">
							<ul className="navbar-nav menu-open">
								<li className="current-menu-item">
									<Link to="/">Home</Link>
								</li>
								{categories.map(category => (
									<li key={category.id}>
										<Link to={`/cat-news/${category.id}`}>{category.category}</Link>
									</li>
								))}
							</ul>
						</div>
						<div className="nav-right-part nav-right-part-desktop">
							<div className="menu-search-inner">
								<input type="text" placeholder="Search For" />
								<button type="submit" className="submit-btn"><i className="fa fa-search" /></button>
							</div>
						</div>
					</div>
				</nav>
			</div>
		)
	}
}


export default Navbar